import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { EdgePoolError } from '../../sections/types/EdgePoolError';
import { PoolModel } from '../../sections/types/PoolModel';

export interface ICreateEdgePoolParams {
  displayName: string;
  bridgeSettingsVersion: string;
  siteId: string;
}

export interface ICreateEdgePoolResult extends IResult {
  success?: {
    pool: PoolModel;
    siteID: string;
  };
  error?: EdgePoolError;
  bridgeSettingsVersion: string;
}

export class CreateEdgePoolRequest extends Request<ICreateEdgePoolParams, ICreateEdgePoolResult> {
  constructor(params: ICreateEdgePoolParams) {
    super('createEdgePool', params);
  }
}
